import { t } from "@web-monorepo/i18n/macro";
import { DDSIconButton } from "@web-monorepo/dds";
import { IconArrowLeft } from "@web-monorepo/dds-icons";
import React from "react";
import styles from "./WithOnlyBackButton.module.css";

type WithOnlyBackButtonProps = {
  children: React.ReactNode;
  className?: string;
};

export default function WithOnlyBackButton({ children, className }: WithOnlyBackButtonProps) {
  return (
    <div>
      <div className={styles.backButton}>
        {/* className passes through to the button (preserves the pre-migration
            contract; the original `className={className}` lived on the raw
            <button>). DDSIconButton merges this with its own variant class. */}
        <DDSIconButton
          variant="transparent"
          aria-label={t`Go back`}
          data-name="with_only_back_button:material_icon"
          onClick={() => window.history.back()}
          className={className}
        >
          <IconArrowLeft />
        </DDSIconButton>
      </div>
      {children}
    </div>
  );
}
